var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Field } from 'react-final-form';
import { P } from '@tpr/core';
import { CheckboxChecked, CheckboxBlank } from './icons';
import { StyledInputLabel } from '../elements';
import { HiddenInput } from '../hidden/hidden';
import styles from './checkbox.module.scss';
import AccessibilityHelper from '../accessibilityHelper';
export var Checkbox = function (_a) {
    var id = _a.id, cfg = _a.cfg, _b = _a.disabled, disabled = _b === void 0 ? false : _b, testId = _a.testId, checked = _a.checked, onChange = _a.onChange, label = _a.label, hint = _a.hint, className = _a.className;
    var msg = testId ? testId + "-" + (checked ? 'checked' : 'unchecked') : null;
    var helper = new AccessibilityHelper(id, !!label, !!hint);
    return (React.createElement(StyledInputLabel, { element: "div", className: className, cfg: Object.assign({
            mt: 1,
            mb: 1,
            alignItems: 'flex-start',
            flexDirection: 'column',
        }, cfg) },
        React.createElement("label", { id: helper && helper.labelId, "data-testid": msg, className: styles.wrapper, htmlFor: id },
            React.createElement(HiddenInput, { id: id, type: "checkbox", "aria-describedby": helper && helper.hintId, checked: checked, disabled: disabled, onChange: onChange }),
            checked ? (React.createElement(CheckboxChecked, { className: styles.checkbox })) : (React.createElement(CheckboxBlank, { className: styles.checkbox })),
            React.createElement(P, { cfg: { ml: 3, fontWeight: 3 }, className: styles.label }, label)),
        hint && (React.createElement(P, { id: helper.hintId, className: styles.hint }, hint))));
};
export var FFCheckbox = function (fieldProps) {
    var handleChange = function (input, value) {
        input.onChange(!input.checked);
        fieldProps.callback && fieldProps.callback(value);
    };
    return (React.createElement(Field, __assign({}, fieldProps, { type: "checkbox", render: function (_a) {
            var label = _a.label, input = _a.input, rest = __rest(_a, ["label", "input"]);
            return (React.createElement(Checkbox, __assign({ label: label, checked: input.checked, onChange: function (e) { return handleChange(input, e.target.checked); } }, rest)));
        } })));
};
//# sourceMappingURL=checkbox.js.map